import Header from './header';

function global() {
  const header = document.querySelector('.header');
  if (header) {
    new Header(header);
  }
}

export default global;
